import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  signal,
} from '@angular/core';

import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Guid, Nillable, valueOrDefault } from '@web/utils';
import { WarehouseFileUploadComponent } from '../warehouse-file-upload/warehouse-file-upload.component';

@Component({
  selector: 'app-warehouse-files-upload',
  imports: [WarehouseFileUploadComponent],
  templateUrl: './warehouse-files-upload.component.html',
  styleUrl: './warehouse-files-upload.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => WarehouseFilesUploadComponent),
      multi: true,
    },
  ],
})
export class WarehouseFilesUploadComponent implements ControlValueAccessor {
  /* prettier-ignore */
  protected readonly allowedMimeTypes = 'image/png, image/apng, image/vnd.mozilla.apng, image/jpeg, image/gif, image/webp, image/svg+xml, image/svg, application/pdf';
  protected readonly disabled = signal(false);
  protected readonly selectedFileIds = signal<Guid[]>([]);
  protected readonly maxFileSize = 5 * 1000 * 1000;

  private onChange!: (value: Nillable<Guid[]>) => void;
  private onTouched!: () => void;

  public writeValue(value: Nillable<Guid[]>): void {
    this.selectedFileIds.set(valueOrDefault(value, []));
  }

  public registerOnChange(fn: (value: Nillable<Guid[]>) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }

  protected handleSelectFilesEvent(ids: Guid[]): void {
    this.onChange(ids);
    this.onTouched();
  }
}
